import React, {createContext, useContext, useEffect, useState} from 'react';
import styled from 'styled-components';
import {CircularProgress} from '@mui/material';
import server, { SERVER, getAccessToken, getTokenUserId, onSessionChange } from '../global/server';
import io from 'socket.io-client';
import { useServerTime } from '../hooks/useServerTime';

const AppContext = createContext({});

export const AppProvider = props => {
    const [loading, setLoading] = useState(false);
    const [isOffline, setOnline] = useState(false);
    const { now: serverNow } = useServerTime();

    // Estado, e nao ref: a conexao so existe depois do primeiro render, e quem
    // consome o contexto precisa ser avisado quando ela aparecer. Guardada numa
    // ref, ela chegava aos filhos como undefined e o componente que se
    // inscrevia no socket nunca chegava a se inscrever.
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const conexao = io.connect(SERVER, {
            transports: ['websocket'],
            // O servidor usa o token para colocar a conexao na sala do usuario
            // (e na dos admins, se for o caso). Sem ele a conexao ainda vale
            // para os eventos abertos, mas nao recebe nada dirigido.
            // Funcao, e nao objeto: a cada reconexao o token e lido de novo,
            // que e o que faz a sala voltar depois de um refresh de sessao.
            auth: cb => cb({ token: getAccessToken() }),
        });

        conexao.on('connect_error', e => console.log(e.message));
        setSocket(conexao);

        // A identificacao acontece uma unica vez, quando a conexao sobe. Quem
        // abre o app deslogado conecta anonimo, e entrar na conta depois nao
        // muda mais nada do lado do servidor: a pessoa fica fora da propria
        // sala ate dar F5, e mensagem nenhuma chega em tempo real. Reconectar
        // na troca de sessao e o que refaz as salas.
        let identidade = getTokenUserId();
        const pararDeOuvir = onSessionChange(atual => {
            // Renovacao de token nao muda quem esta logado: a conexao ja esta
            // na sala certa e derruba-la a cada 15 minutos so abriria buraco
            if (atual === identidade) return;

            identidade = atual;
            conexao.disconnect();
            conexao.connect();
        });

        return () => {
            pararDeOuvir();
            conexao.close();
        };
    }, []);

    return (
        <AppContext.Provider
            value={{
                loading,
                setLoading,
                isOffline,
                socket,
                serverNow,
            }}>
            <>
                {props.children}
                {/* <Loading loading={loading}>
                    <CircularProgress />
                </Loading> */}
            </>
        </AppContext.Provider>
    );
};

export const useApp = () => {
    const context = useContext(AppContext);
    if (!context) throw 'useApp context inside corret provider';

    return context;
};

const Loading = styled.div`
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: ${props => props.loading};
    z-index: 999;
    align-items: center;
    justify-content: center;
`;
